import {
  BLOCKED_ANALYTICS_SCRIPT_PATTERNS,
  CHUNK_ERROR_PATTERNS,
} from '~/constants/datadog'

/**
 * Checks if a loading error is (likely) related to chunks.
 *
 * @param message The error message
 * @returns true when the message matches the pattern
 */
export function isChunkLoadErrorMessage(message: string): boolean {
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

/**
 * Checks if an error was caused by a blocked analytics script (e.g. GTM/gtag).
 *
 * @param message The error message
 * @param stack The error stack trace
 * @returns true when the message or stack matches a blocked-analytics pattern
 */
export function isBlockedAnalyticsScriptError(message: string, stack?: string): boolean {
  const haystack = `${message}${stack ?? ''}`
  return BLOCKED_ANALYTICS_SCRIPT_PATTERNS.some((pattern) => pattern.test(haystack))
}
